module.exports = __webpack_public_path__ + "static/img/bak2.ad92d6f.png";


//////////////////
// WEBPACK FOOTER
// ./static/ing1/bak2.png
// module id = znG6
// module chunks = 0